import { render, staticRenderFns } from "./lisa_kasutaja.vue?vue&type=template&id=59c398c8&"
import script from "./lisa_kasutaja.vue?vue&type=script&lang=js&"
export * from "./lisa_kasutaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports